<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a class="block xl:hidden menu_submenu_user__email" @click.prevent>
            <span class="text-white">{{ email }}</span>
        </a>
        <div class="field-switcher menu_submenu_user__menu_switcher m-0">
            <label for="option-left-menu">{{ $t('lang.menu.left_menu_setting') }}</label>
            <InputSwitch
                v-model="model.isLeftMenu"
                inputId="option-left-menu"
                @update:modelValue="onChangeLeftMenu"
            />
        </div>
        <Divider class="m-0 block md:hidden menu_submenu_user__divider" />
        <a :href="getLink('/panel')">
            <i class="ksi ksi-panel"></i>
            <span>{{ $t('lang.menu.user_panel') }}</span>
        </a>
        <a :href="getLink('/history')">
            <i class="ksi ksi-history"></i>
            <span>{{ $t('lang.menu.user_history') }}</span>
        </a>
        <a :href="getLink('/partner')">
            <i class="ksi ksi-partner"></i>
            <span>{{ $t('lang.menu.user_partner') }}</span>
        </a>
        <a :href="getLink('/logout')">
            <i class="ksi ksi-logout"></i>
            <span>{{ $t('lang.menu.user_logout') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Divider from "primevue/divider";
import InputSwitch from "primevue/inputswitch";
import UserApi from "../../../api/UserApi";

export default {
    name: "MenuSubmenuTopUser",
    props: {
        email: {
            type: String,
            required: false,
        },
        isLeftMenu: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_USER_HOVER,
            model: {
                isLeftMenu: this.isLeftMenu,
            },
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
        onChangeLeftMenu(value) {
            UserApi
                .setSettings({isLeftMenu: value})
                .then(() => window.location.reload())
                .catch(error => this.alertError(error));
        },
    },
    components: {
        InputSwitch,
        Divider,
        MenuBaseSubmenu,
    },
}
</script>

<style scoped>
.menu_submenu_user__divider:before {
    border-top: 1px solid #6C757D !important;
}
.menu_submenu_user__menu_switcher {
    display: flex;
    justify-content: space-between;
    padding: 16px 22px;
}
@media (min-width: 1200px) and (max-width: 1500px) {
    .menu_submenu_user__email {
        display: block !important;
        cursor: default;
    }
    .menu_submenu_user__divider {
        display: block !important;
    }
}
</style>

<style>
.menu_submenu_user__menu_switcher label {
    color: #A4B1BE !important;
    margin-left: 0 !important;
    font-size: 13px;
}
.menu_submenu_user__menu_switcher .p-inputswitch {
    height: 22px;
}
.menu_submenu_user__menu_switcher .p-inputswitch-slider {
    width: 42px;
}
.menu_submenu_user__menu_switcher .p-inputswitch-slider:before {
    left: 2px;
}
.menu_submenu_user__menu_switcher .p-inputswitch-slider:before {
    height: 18px;
    width: 18px;
    top: 55%;
}
.menu_submenu_user__menu_switcher .p-highlight .p-inputswitch-slider:before {
    transform: translateX(18px) !important;
}
</style>
